<network-left-side-nav
  [sideNavOptions]="sideNavOptions"
></network-left-side-nav>


<div class="outlet-wrapper" [ngClass]="{ 'with-sub-nav': showSubNav$ | async }">
  <page-banner 
  [meta]="pageBannerMeta$ | async"
  [showSubNav]="showSubNav$ | async"
  >
    <div *ngIf="subNavConfig$ | async as subNavConfig">
      <nv-sub-nav
        [navigationTabs$]="navigationTabs$" 
        [showSubNav$]="showSubNav$"
        [showWarningMessage]="subNavConfig.showWarningMessage"
        [warningMessage]="subNavConfig.warningMessage"
        [warningTooltip]="subNavConfig.warningTooltip"
        [nvNotePriority]="subNavConfig.nvNotePriority || 'warning'"
        [filterConfigs]="subNavConfig.filterConfigs"
        [actionButton]="subNavConfig.actionButton"
        [origin]="origin"
        [portal]="partnerType">
      </nv-sub-nav>
    </div>
  </page-banner>
  <ng-container *ngTemplateOutlet="isInMaintenanceMode ? maintenanceOn : maintenanceOff"></ng-container>
</div>

<ng-template #maintenanceOff>
  <router-outlet></router-outlet>
</ng-template>

<ng-template #maintenanceOn>
  <maintenance-mode></maintenance-mode>
</ng-template>
